module.exports = __webpack_public_path__ + "img/DE03720.47960fd3.png";